// Fix console.debug on IE10
/* eslint-disable no-console */
if (console && typeof console.debug !== 'function') {
	console.debug = console.info;
}
/* eslint-enable no-console */
